<template>
  <div class="card" id="mycard">
    <div class="card-header header-elements-inline">
      <h6 class="card-title">Compare Purchase Vs GSTR 1A</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" data-action="reload" @click="resetWindow"></a>
          <a class="list-icons-item" data-action="remove" @click="closeWindow"></a>
        </div>
      </div>
    </div>

    <div class="card-body">
      <ul class="nav nav-tabs nav-tabs-highlight nav-justified">
        <li class="nav-item"><a href="#highlighted-justified-tab1" class="nav-link active show" data-toggle="tab">Upload Data</a></li>
        <li class="nav-item"><a href="#highlighted-justified-tab2" class="nav-link" data-toggle="tab">Tally Purchase</a></li>
        <li class="nav-item"><a href="#highlighted-justified-tab3" class="nav-link" data-toggle="tab">Portal Data</a></li>
        <li class="nav-item dropdown">
          <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false">Difference</a>
          <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(247px, 42px, 0px);">
            <a href="#highlighted-justified-tab4" class="dropdown-item" data-toggle="tab">Missed in Portal</a>
            <a href="#highlighted-justified-tab5" class="dropdown-item" data-toggle="tab">Missed in Tally</a>
          </div>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane fade active show" id="highlighted-justified-tab1">

          <form id="uploadfile" method="post" enctype="multipart/form-data">
            <div class="row">
              <div class="col-md-6">
                <label for="purchasefile">Purchase Excel Data Sheet</label>
                <div class="file-loading">
                  <input id="purchasefile" name="purchasefile" type="file" ref="myPurchaseFiles" @change="purchasefile_select_event" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"  data-fouc  >
                </div>
              </div>

              <div class="col-md-6">
                <label for="portalfile">Downloaded Portal Data</label>
                <div class="file-loading">
                  <input id="portalfile" name="portalfile" type="file" ref="myPortalFiles" @change="portalfile_select_event" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"  data-fouc >
                </div>
              </div>

            </div>

          </form>

          <div class="row" style="padding-top: 30px;">
            <div class="col-md-12 text-center">

              <button class="btn btn-outline-primary" @click="saveFile">Upload To Server</button>
            </div>
          </div>

        </div>

        <div class="tab-pane fade " id="highlighted-justified-tab2">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
              <tr>
                <th>#</th>
                <th>Particulars</th>
                <th>GSTIN</th>
                <th>Invoice No</th>
                <th>Date</th>
                <th>Taxable</th>
                <th>IGST</th>
                <th>CGST</th>
                <th>SGST</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="(detail,idx) in purchasedata">
                <td> {{idx + 1}}</td>
                <td>{{detail[7]}}</td>
                <td>{{detail[0]}}</td>
                <td>{{detail[1]}}</td>
                  <td style="padding: 3px;width: 75px;text-align: center;">{{detail[2]}}</td>
                <td class="text-right">{{detail[3] | indianFormat}}</td>
                <td class="text-right">{{detail[4] | indianFormat}}</td>
                <td class="text-right">{{detail[5] | indianFormat}}</td>
                <td class="text-right">{{detail[6] | indianFormat}}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="tab-pane fade" id="highlighted-justified-tab3">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
              <tr>
                <th>#</th>
                <th>Particulars</th>
                <th>GSTIN</th>
                <th>Invoice No</th>
                <th>Date</th>
                <th>Taxable</th>
                <th>IGST</th>
                <th>CGST</th>
                <th>SGST</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detail,idx) in portaldata">
                <td> {{idx + 1}}</td>
                <td>{{detail[7]}}</td>
                <td>{{detail[0]}}</td>
                <td>{{detail[1]}}</td>
                <td style="padding: 3px;width: 75px;text-align: center;">{{detail[2]}}</td>
                <td class="text-right">{{detail[3] | indianFormat}}</td>
                <td class="text-right">{{detail[4] | indianFormat}}</td>
                <td class="text-right">{{detail[5] | indianFormat}}</td>
                <td class="text-right">{{detail[6] | indianFormat}}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="tab-pane fade" id="highlighted-justified-tab4">
          <div >
            <h5>Missed in Portal</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Particulars</th>
                  <th>GSTIN</th>
                  <th>Invoice No</th>
                  <th>Date</th>
                  <th>Taxable</th>
                  <th>IGST</th>
                  <th>CGST</th>
                  <th>SGST</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(detail,idx) in miss_n_portal">
                  <td> {{idx + 1}}</td>
                  <td>{{detail[7]}}</td>
                  <td>{{detail[0]}}</td>
                  <td>{{detail[1]}}</td>
                  <td style="padding: 3px;width: 75px;text-align: center;">{{detail[2]}}</td>
                  <td class="text-right">{{detail[3] | indianFormat}}</td>
                  <td class="text-right">{{detail[4] | indianFormat}}</td>
                  <td class="text-right">{{detail[5] | indianFormat}}</td>
                  <td class="text-right">{{detail[6] | indianFormat}}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="highlighted-justified-tab5">
          <div >
            <h5>Missed in Tally</h5>
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Particulars</th>
                  <th>GSTIN</th>
                  <th>Invoice No</th>
                  <th>Date</th>
                  <th>Taxable</th>
                  <th>IGST</th>
                  <th>CGST</th>
                  <th>SGST</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(detail,idx) in miss_n_tally">
                  <td> {{idx + 1}}</td>
                  <td>{{detail[7]}}</td>
                  <td>{{detail[0]}}</td>
                  <td>{{detail[1]}}</td>
                  <td style="padding: 3px;width: 75px;text-align: center;">{{detail[2]}}</td>
                  <td class="text-right">{{detail[3] | indianFormat}}</td>
                  <td class="text-right">{{detail[4] | indianFormat}}</td>
                  <td class="text-right">{{detail[5] | indianFormat}}</td>
                  <td class="text-right">{{detail[6] | indianFormat}}</td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment-timezone'
  import { userService } from '@/store/auth-header.js'
  import { store } from '@/store/store.js'

  export default {
    name: 'ActualvsPortal',
    data(){
      return {
        formatter: new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }),
        purchasefile: {'filename':'','filedata':''},
        portalfile: {'filename':'','filedata':''},
        purchasedata:[],
        portaldata:[],
        miss_n_portal:[],
        miss_n_tally:[],
      }
    },
    mounted () {
      const self = this;

      $("#purchasefile").fileinput({
        'showUpload':false,
        overwriteInitial: true,
        allowedFileExtensions: ["xls", "xlsx"],
        maxFileSize: 1024,
        initialCaption: "Purchase File",
        browseLabel: 'Select Purchase File',
        browseIcon: '<i class="icon-file-plus mr-2"></i>',
        removeIcon: '<i class="icon-cross2 font-size-base mr-2"></i>',
      });

      $("#portalfile").fileinput({
        'showUpload':false,
        overwriteInitial: true,
        maxFileSize: 1024,
        initialCaption: "Portal File",
        allowedFileExtensions: ["xls", "xlsx"],
        browseLabel: 'Select Portal File',
        browseIcon: '<i class="icon-file-plus mr-2"></i>',
        removeIcon: '<i class="icon-cross2 font-size-base mr-2"></i>',
      });
    },
    filters:{
      indianFormat(val){
        if (val > 0)
          return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(val);
        else
          // return parseFloat(val).toFixed(2);
          return '';
      }
    },
    methods:{
      closeWindow(){
        this.$router.push('/');
      },
      resetWindow(){
        this.$data.purchasefile = {'filename':'','filedata':''};
        this.$data.portalfile = {'filename':'','filedata':''};
        this.$data.purchasedata = [];
        this.$data.portaldata =[];
        this.$data.miss_n_portal =[];
        this.$data.miss_n_tally = [];
        // $('#purchasefile').val('');
        // $('#portalfile').val('');

      },
      purchasefile_select_event(){
        const self = this;
        try {

          self.$data.purchasefile = {'filename':'','filedata':''};

          let reader = new FileReader();

          if( this.$refs.myPurchaseFiles.files.length > 0 ) {
            reader.readAsDataURL(this.$refs.myPurchaseFiles.files[0]);
            reader.onload = function () {
              self.$data.purchasefile.filedata = reader.result;
              self.$data.purchasefile.filename = self.$refs.myPurchaseFiles.files[0].name;
            };
            reader.onerror = function (error) {
              swal({ title: 'Oops!', text: error.toString(), type: 'error' });
            };
          }
        }catch (e) {
          swal({ title: 'Oh noes!', text: e.toString(), type: 'error' });
        }
      },
      portalfile_select_event(){
        const self = this;
        try {

          self.$data.portalfile = {'filename':'','filedata':''};

          let reader = new FileReader();

          if( self.$refs.myPortalFiles.files.length > 0 ) {
            reader.readAsDataURL(self.$refs.myPortalFiles.files[0]);
            reader.onload = function () {
              self.$data.portalfile.filename = self.$refs.myPortalFiles.files[0].name;
              self.$data.portalfile.filedata = reader.result;
            };
            reader.onerror = function (error) {
              swal({ title: 'Oops!', text: error.toString(), type: 'error' });
            };
          }
        }catch (e) {
          swal({ title: 'Oh noes!', text: e.toString(), type: 'error' });
        }
      },
      saveFile(){

        const self = this;

        if( $('#purchasefile').val().trim().length == 0 ){
          swal({ title: 'Info!', text: 'Invalid Purchase File', type: 'info' });
          return;
        }else if( $('#portalfile').val().trim().length == 0 ){
          swal({ title: 'Info!', text: 'Invalid Portal File', type: 'info' });
          return;
        }

        let mydata = {'purchasefile': self.$data.purchasefile, 'portalfile': self.$data.portalfile };

        const requestOptions = {
          method: 'POST',
          mode: 'cors',
          headers: userService.authHeader(),
          body: JSON.stringify(mydata)
        }

        $('#mycard').block({
          message: '<i class="icon-spinner2 spinner"></i>',
          overlayCSS: {
            backgroundColor: '#fff',
            opacity: 0.8,
            cursor: 'wait',
            'box-shadow': '0 0 0 1px #ddd'
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: 'none'
          }
        });

        fetch(`${process.env.VUE_APP_ROOT_API}api/v1/gst/upload/`, requestOptions).then(userService.handleResponse).then(function (resp) {
          if (resp.accepted) {

              self.$data.purchasedata = resp.data.purchase;
              self.$data.portaldata = resp.data.portal;
              self.$data.miss_n_portal = resp.data.miss_n_portal;
              self.$data.miss_n_tally = resp.data.miss_n_tally;

              swal({ title: 'success', text: resp.msg, type: 'success' });

          } else {
            swal({ title: 'Oops!', text: resp.msg, type: 'error' })
          }
        }).catch(function (err) {
          swal({ title: 'Oh noes!', text: err.toString(), type: 'error' });
        }).finally(()=>{
          $('#mycard').unblock();
        });

      }
  }

  }
</script>

<style scoped>

</style>
